import { render } from "./AddCategoryManagerPopup.vue?vue&type=template&id=62f8c077"
import script from "./AddCategoryManagerPopup.vue?vue&type=script&lang=js"
export * from "./AddCategoryManagerPopup.vue?vue&type=script&lang=js"

import exportComponent from "/srv/www/nahodka.xpage.dev/htdocs/public/local/client-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__